module.exports = __webpack_public_path__ + "static/portfolio-mas-1-bdced2608ed402df1b1cde8712c8ee06.jpg";